require('./bootstrap');
import VueLazyload from "vue-lazyload";
import { createApp } from 'vue';
import SearchHome from "./components/parts/SearchHome.vue";
import Search from "./components/Search.vue";
import Languages from "./components/Languages.vue";
import Currencies from "./components/Currencies";
import SearchFormHome from "./components/SearchFormHome.vue";
import SetDefaultCurrency from "./components/SetDefaultCurrency";

const app = createApp({
    components: {
        SearchHome,
        Search,
        Languages,
        SearchFormHome,
        Currencies,
        SetDefaultCurrency
    }
});
app.use(VueLazyload);
app.mount('#vue-app');
